import { render, staticRenderFns } from "./CreateNewStatusModal.vue?vue&type=template&id=1e1397b4"
import script from "./CreateNewStatusModal.vue?vue&type=script&lang=js"
export * from "./CreateNewStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports